// VERSION 1.0.0
// AUTHOR: AGALYA

import CommonTransferLogActionTypes from './common-transfer-log.types';

/*************** FETCH TRANSFER LOG START  ******************/
export const fetchTransferLogListStart = (getData: any) => ({
	type: CommonTransferLogActionTypes.FETCH_TRANSFER_LOG_LIST_START,
	payload: getData,
});

export const fetchTransferLogListSuccess = (successData: any) => ({
	type: CommonTransferLogActionTypes.FETCH_TRANSFER_LOG_LIST_SUCCESS,
	payload: successData,
});

export const fetchTransferLogListFailure = (failureData: any) => ({
	type: CommonTransferLogActionTypes.FETCH_TRANSFER_LOG_LIST_FAILURE,
	payload: failureData,
});

export const fetchTransferLogListResponseResetStart = () => ({
	type: CommonTransferLogActionTypes.FETCH_TRANSFER_LOG_LIST_RESPONSE_RESET_START,
});

export const fetchTransferLogListResponseChanged = () => ({
	type: CommonTransferLogActionTypes.FETCH_TRANSFER_LOG_LIST_RESPONSE_CHANGED,
});
/*************** FETCH TRANSFER LOG END ******************/

/***************  GET MEMBER APPROVE LIST START  ******************/
export const getMemberApproveListStart = (getData: any) => ({
	type: CommonTransferLogActionTypes.GET_MEMBER_APPROVE_LIST_START,
	payload: getData,
});

export const getMemberApproveListSuccess = (successData: any) => ({
	type: CommonTransferLogActionTypes.GET_MEMBER_APPROVE_LIST_SUCCESS,
	payload: successData,
});

export const getMemberApproveListFailure = (failureData: any) => ({
	type: CommonTransferLogActionTypes.GET_MEMBER_APPROVE_LIST_FAILURE,
	payload: failureData,
});

export const getMemberApproveListResponseResetStart = () => ({
	type: CommonTransferLogActionTypes.GET_MEMBER_APPROVE_LIST_RESPONSE_RESET_START,
});

export const getMemberApproveListResponseChanged = () => ({
	type: CommonTransferLogActionTypes.GET_MEMBER_APPROVE_LIST_RESPONSE_CHANGED,
});
/***************  GET MEMBER APPROVE LIST END  ******************/

/***************  CHANGE STATUS TRANSFER LOG START ******************/
export const changeStatusTransferLogStart = (getData: any) => ({
	type: CommonTransferLogActionTypes.CHANGE_STATUS_TRANSFER_LOG_START,
	payload: getData,
});

export const changeStatusTransferLogSuccess = (successData: any) => ({
	type: CommonTransferLogActionTypes.CHANGE_STATUS_TRANSFER_LOG_SUCCESS,
	payload: successData,
});

export const changeStatusTransferLogFailure = (failureData: any) => ({
	type: CommonTransferLogActionTypes.CHANGE_STATUS_TRANSFER_LOG_FAILURE,
	payload: failureData,
});

export const changeStatusTransferLogResponseResetStart = () => ({
	type: CommonTransferLogActionTypes.CHANGE_STATUS_TRANSFER_LOG_RESPONSE_RESET_START,
});

export const changeStatusTransferLogResponseChanged = () => ({
	type: CommonTransferLogActionTypes.CHANGE_STATUS_TRANSFER_LOG_RESPONSE_CHANGED,
});
/***************  CHANGE STATUS TRANSFER LOG END ******************/

/*********  MEMBER FOR TRANSFER CENTER START *********/
export const memberForTransferCenterStart = (getData: any) => ({
	type: CommonTransferLogActionTypes.MEMBER_FOR_TRANSFER_CENTER_START,
	payload: getData,
});

export const memberForTransferCenterSuccess = (successData: any) => ({
	type: CommonTransferLogActionTypes.MEMBER_FOR_TRANSFER_CENTER_SUCCESS,
	payload: successData,
});

export const memberForTransferCenterFailure = (failureData: any) => ({
	type: CommonTransferLogActionTypes.MEMBER_FOR_TRANSFER_CENTER_FAILURE,
	payload: failureData,
});

export const memberForTransferCenterResponseResetStart = () => ({
	type: CommonTransferLogActionTypes.MEMBER_FOR_TRANSFER_CENTER_RESPONSE_RESET_START,
});

export const memberForTransferCenterResponseChanged = () => ({
	type: CommonTransferLogActionTypes.MEMBER_FOR_TRANSFER_CENTER_RESPONSE_CHANGED,
});
/*********  MEMBER FOR TRANSFER CENTER END *********/
